import * as React from "react";
import { useState } from "react";
import { InputStepperText } from '../../../input-components/input-stepper-text';
import Select from 'react-select';
import fetch from 'cross-fetch';

export interface IWebshopProductDetailEdit {
  addToCartButtonText: string;
  stock : number;
  tracksStock: boolean;
  onClickAddButton: (productId) => void;  
  onChangeValue: (value : number) => void;
  variants : any[];
  productId: string;
}
export const WebshopProductDetailEdit = (props: IWebshopProductDetailEdit) => {
  const [ options , setOptions ] = useState([]);
  const [ selectedProduct, setSelectedProduct] = useState("");
  const [ stock , setStock] = useState(props.stock);
  const [ error , setError] = useState("");
  
  React.useEffect(() => {
    let newOptions : any[] = [];
    props.variants.map((variant) => {
      newOptions.push({
        value: variant.skuId.toString(),
        label: variant.name
      });
    });
    setOptions(newOptions);
  }, [props.variants, props.productId]);
  

  const styles = {
    clearIndicator: () => undefined,
    container: () => undefined,
    control: () => undefined,
    dropdownIndicator: () => undefined,
    groupHeading: () => undefined,
    indicatorsContainer: () => undefined,
    indicatorSeparator: () => undefined,
    input: () => undefined,
    loadingIndicator: () => undefined,
    loadingMessage: () => undefined,
    menu: () => undefined,
    menuList: () => undefined,
    multiValue: () => undefined,
    multiValueLabel: () => undefined,
    multiValueRemove: () => undefined,
    noOptionsMessage: () => undefined,
    option: () => undefined,
    placeholder: () => undefined,
    singleValue: () => undefined,
    valueContainer: () => undefined
  };

  const onClick = () => {
    let productId = props.productId;
    if (props.variants.length > 0) {
      if (selectedProduct != "") {
        props.onClickAddButton(selectedProduct);
      } else {
        setError("'Selecteer een maat' is een verplicht veld.");
      }
    } else {
      props.onClickAddButton(productId);
    }
  };

  const onChange = (value: any) => {
    if (value && value.value) {
      setError("");
      setSelectedProduct(value.value);

      fetch("/api/shoppingbasket/getstockforproductid?skuId=" + value.value, {
        method: 'get'      
      }).then(response => {
        if (response.status >= 300) {
          return "error";
        } else {
          return response.text();
        }
      }).then((data) => {
        if (data != "error") {
          setStock(parseInt(data as any) || 0); 
        }
      });      
    }
  };

  const onChangeValue = (value: number) => {
    props.onChangeValue(value);
  };
  
  return <div className="webshop-product-detail-edit form">
      {props.variants.length > 0 && <div className="form-group">
        <label>Selecteer een maat *</label>
        <Select 
          onChange={onChange}
          styles={styles} 
          classNamePrefix="form-dropdown" 
          className="form-dropdown__container form-control"           
          options={options}></Select>
        {error != "" && <div className="webshop-product-detail-edit__error">{error}</div>}
      </div>}
      <div className="form-group">
        <label>Hoeveelheid</label>
        <InputStepperText onChangeValue={onChangeValue} maxValue={999} value={1} enableTextInput={true}></InputStepperText>
        {props.tracksStock && props.variants.length == 0 && 
          <p className="webshop-product-detail-edit__stock-info"><span className="icon icon-information"></span>Nog {props.stock} beschikbaar</p>}
        {props.tracksStock && selectedProduct != "" && props.variants.length > 0 && 
          <p className="webshop-product-detail-edit__stock-info"><span className="icon icon-information"></span>Nog {stock} beschikbaar</p>}
      </div>
      <button onClick={onClick}
        className="btn btn-success webshop-product-detail__add-button">
        <span className="webshop-product-card__add-button-text">+</span>
        <span>{props.addToCartButtonText}</span>
      </button>
    </div>;
};
